
import { Helmet } from 'react-helmet';
import NProgress from 'nprogress';

const RulesPage = () => {
  const smsServiceRules = [
    {
      rule: "SMS ugratmazdan öň, telefon belgisiniň dogrulandygyna göz ýetiriň.",
      description: "Her bir SMS ugratmadan ozal, telefon belgisi dogry we mümkin bolan ýagdaýda täzelemegi üpjün ediň. Ulgamda bellenen ýalňyş telefon belgileri SMS iberilmegine päsgel berip biler.",
    },
    {
      rule: "SMSleriň wagtyny we talaplaryny yzarlaň.",
      description: "SMS iberilende, her bir ugradylan hatyň wagty, statusy we müşderi talaplary göz öňünde tutulmalydyr. SMS wagtynyň we aralygynyň öňünden kesgitlenendigi, serwisleriň doly we wagtlaýyn hyzmat etmegini üpjün eder.",
    },
    {
      rule: "SMS statuslaryny yzarlamak we päsgelçilikleri çözmek.",
      description: "Serwisde her bir SMS'nin statusy (nosend, send, failed, nobalance) yzarlanylmalydyr. Eger SMS ugradylmasa, arza bermek üçin ulanyjynyň telefon balansasyny ýa-da nätanyş belgilerden iberilmegini gözden geçiriň.",
    },
    {
      rule: "Balans we funksiýalary gözden geçiriň.",
      description: "SMS hyzmaty ulanyjynyň balansyna görä işlemeli. Pul ýok ýa-da balansda ýer bolmadyk ýagdaýda SMS ugratmak bolmaz. Ulanyjynyň balansynyň doly ýa-da täzelenen ýagdaýda ulanylyp bilinjekdigini ykrar ediň.",
    },
    {
      rule: "SMS ugratmakda talaplaryň ykrar edilmegine göz ýetiriň.",
      description: "Ulanyjy SMS ibermäge başlamazdan öň, ähli talaplaryň we düzgünleriň kabul edilmegine göz ýetiriň. Şeýle hem, SMS serwisini nädogry ulanmakdan goramak üçin ulanyjynyň maglumatlaryny gizlin saklanyň.",
    },
    {
      rule: "SMS ugratmak üçin degişli protokollary ulanyň.",
      description: "SMS serwisini ulanýança degişli SMS protokollary we ulanyjy maglumatlaryny dolandyrmak üçin serwis bilen baglanyşykly ähli talaplary we düzgünleri ýerine ýetiriň. Häzirki wagtda SMS hyzmaty üçin SMS API-lerini we tolgundyryş protokollaryny ulanmak gerek.",
    },
    {
      rule: "Serwis täzelenişleri we durkuny yzarlamak.",
      description: "SMS serwisiniň ösüşini we täzelenişlerini yzygiderli yzarlap, ulanyjylar üçin has gowy şertler döredilýär. Her gezek täze täzelenişler bilen, ulanyjylar habarly edilmelidir.",
    },
    {
      rule: "Ulgamda amala aşyran SMS'leri we olaryň netijelerini yzarlaň.",
      description: "Serwisde amala aşyran SMS'leriň netijelerini (ugradylyp, ugradylmadyk ýa-da näsazlyk statusy) yzarlamak we hasaplama arkaly her bir SMS-ä degişli maglumatlary saklamak möhüm.",
    }
  ];
  NProgress.start();
  NProgress.done();
  return (<>
    <Helmet>
      <title>SMS Serwis - Düzgünler</title>
    </Helmet>

    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-medium text-gray-900 mb-4">SMS Serwis Düzgünleri</h2>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              {['#', 'Düzgün', 'Giňişleýin'].map((h, i) => (
                <th key={i} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {smsServiceRules.map((rule, idx) => (
              <tr key={idx}>
                <td className="px-6 py-4 text-sm text-gray-500">{idx + 1}</td>
                <td className="px-6 py-4 text-sm text-gray-900">{rule.rule}</td>
                <td className="px-6 py-4 text-sm text-gray-700">{rule.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </>
  );
};

export default RulesPage;
